import {
	ApiUtils,
	_axios
}from '@/api/apiUtil.js';
import constant from '@/util/constant.js';
const api = {
	list: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/cw/riems/list", params, successCallback, failCallback, exceptionCallback);
	},listmth: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/cw/riems/mlist", params, successCallback, failCallback, exceptionCallback);
	},pay: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/cw/riems/pay", params, successCallback, failCallback, exceptionCallback);
	},toUpld: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/cw/riems/toUpld", params, successCallback, failCallback, exceptionCallback);
	},toUpdate: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/cw/riems/toUpdate", params, successCallback, failCallback, exceptionCallback);
	},update: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.putLoadingAjax(constant.serverUrl + "/cw/riems/update", params, successCallback, failCallback, exceptionCallback);
	},remove: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.deleteLoadingAjax(constant.serverUrl + "/cw/riems/remove", params, successCallback, failCallback, exceptionCallback);
	},
}

export default api;
